import React from 'react';
import ReactCountdown from 'react-countdown';

function CircleNumber({ number, label }) {
    return (
        <div className="flex w-20 h-20 lg:w-24 lg:h-24 rounded-full border border-brand justify-center items-center relative">
            <div className="absolute w-full h-full pointer-events-none rounded-full border-r-2 border-brand" />
            <div className="text-center">
                <div className="text-2xl lg:text-4xl text-brand font-bold  leading-none font-serif">{number}</div>
                <div className="text-lg">{label}</div>
            </div>
        </div>
    );
}

const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
        // TODO: Do something on completed ??
    }
    return (
        <div className="flex space-x-2 lg:space-x-4">
            <CircleNumber label="dni" number={days} />
            <CircleNumber label="ur" number={hours} />
            <CircleNumber label="minut" number={minutes} />
            <CircleNumber label="sekund" number={seconds} />
        </div>
    );
};

function Countdown({ date }) {
    return (
        <div>
            <ReactCountdown date={date} renderer={renderer} />
        </div>
    );
}

export default Countdown;
